import { ltLogger } from '../../bootstrap/index';
import * as logtypes from '../../common/logtypes';

const phxClientProcess = {
  //Add each client side process node as a function
  googleStreetSuggestions: function (requestData, timeoutCallback) {
    let autocompleteService =
      window.google && new window.google.maps.places.AutocompleteService();
    if (autocompleteService) {
      return new Promise(function (resolve) {
        let resolved = false;
        autocompleteService.getPlacePredictions(
          {
            input: requestData.input,
            componentRestrictions: { country: ['us'] },
            types: ['address'],
          },
          function (places, status) {
            let matches = [];
            try {
              if (status === window.google.maps.places.PlacesServiceStatus.OK) {
                matches = places.map((item) => {
                  let street, city, state;
                  if (item.structured_formatting) {
                    street = item.structured_formatting.main_text;
                    let cityState = item.structured_formatting.secondary_text;
                    if (cityState) {
                      let split = cityState.split(',');
                      if (split && split.length >= 2) {
                        city = split[0];
                        state = split[1];
                      }
                    }
                  }
                  return {
                    displayText: item.description,
                    streetLine: street,
                    cityName: city,
                    stateCode: state ? state.trim() : '',
                    place_id: item.place_id,
                  };
                });
              }
            } catch (error) {
              ltLogger(logtypes.ERROR, undefined, {}, undefined, {
                error: error,
              });
            }
            resolved = true;
            resolve({ matches: matches });
          }
        );
        const ssTimeoutMS = 3 * 1000;
        setTimeout(() => {
          if (!resolved) {
            timeoutCallback && timeoutCallback({ ssTimeoutMS });
            resolve({ matches: [] });
          }
        }, ssTimeoutMS);
      });
    }
    ltLogger(logtypes.ERROR, undefined, {}, undefined, {
      error: 'Could not load Google Street Suggesstion API',
    });
    return Promise.resolve({ matches: [] });
  },
};

const executeProcess = (funcToExec, requestData, timeoutCB) => {
  return phxClientProcess[funcToExec](requestData, timeoutCB);
};

export default executeProcess;
